import { useNavigate, useParams } from 'react-router-dom';
import Container from '../../../../core/components/atoms/Container';
import { Breadcrumbs } from '../../../../core/components/organism/Breadcrumbs';
import { useEssayTheme } from '../../hooks/useEssayTheme';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Chip } from '../../../../core/components/atoms/Chip';
import { essayTitle } from '../../utils';
import { meEssayStore } from '../../stores/meEssayStore';
import { Tag } from '../../../../core/components/atoms/Tag';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Fragment, useCallback, useEffect } from 'react';
import InnerHTMLContainer from '../../../../core/components/molecules/InnerHTMLContainer';
import Player from '../../../../core/components/molecules/Player';
import EssayFooter from '../../components/EssayFooter';
import { useCreateEssay } from '../../hooks/useCreateEssay';
import { useBoardConfig } from '../../../../core/hooks/useBoardConfig';
import { PlayerType } from '../../../../core/models/video';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';
import { useEssayCoreStore } from '../../../../core/stores/essayCoreStore';
import { Button } from '../../../../core/components/atoms/Button';
// import { BadgeScore } from '../../../../core/components/atoms/BadgeScore';

export function StartPage() {
  const navigate = useNavigate();
  const { themeSlug } = useParams();
  const {
    mutate,
    isPending: createLoading,
    isError,
    data: dataCreated,
  } = useCreateEssay();
  const { data, isPending } = useEssayTheme(themeSlug || '');
  const { credits } = meEssayStore();
  const { board } = useBoardConfig(data?.correctionType || 2);
  const { reset } = useEssayCoreStore();

  const startEssay = () => {
    if (data) {
      reset();
      mutate({ theme: data?.themeId, moduleOrigin: 'essay' });
    }
  };

  useEffect(() => {
    if (!isError && dataCreated && dataCreated.ok) {
      navigate(`/redacoes/escrevendo/${themeSlug}`);
    }
  }, [createLoading]);

  const removeAlign = (html?: string) => {
    if (html) {
      html = html.replace(
        /<p[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*left[^'"]*['"]?[^>]*>/gi,
        '<p>'
      );

      html = html.replace(
        /<p[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*right[^'"]*['"]?[^>]*>/gi,
        '<p>'
      );

      html = html.replace(
        /<p[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*center[^'"]*['"]?[^>]*>/gi,
        '<p>'
      );

      return html;
    }

    return '';
  };


  const getVideoWidthClass = useCallback(() => {
    const videoCount = [
      data?.webDoc?.vimeoID,
      data?.themeLesson?.vimeoID,
      data?.teacherLesson?.vimeoID,
    ].filter(Boolean).length;

    if(videoCount === 1) {
      return 'w-full md:w-1/2';
    }

    if(videoCount === 2) {
      return 'w-full md:w-1/2';
    }

    if(videoCount === 3) {
      return 'w-full md:w-1/3';
    }

    return 'w-full md:w-full';
  }, [data?.webDoc?.vimeoID, data?.themeLesson?.vimeoID, data?.teacherLesson?.vimeoID]);

  return (
    <Container
      gap='xxl'
      direction='col'
      type='updated'
      className='xs:mb-[30px] xl:mb-[30px]'
    >
      <Breadcrumbs
        items={[
          {
            label: 'Temas',
            href: '/redacoes/temas',
          },
          {
            label: data?.theme || '',
            href: '#',
          },
        ]}
      />

      {isPending === true ? (
        <BrainLoadingWrapper />
      ) : (
        <Fragment>
          <div className='flex flex-col items-end justify-between gap-sm'>
            <div className='flex w-full flex-row items-start xs:block md:hidden'>
              <Tag
                variant={
                  credits?.remainingCreditsMonth &&
                  credits?.remainingCreditsMonth > 0
                    ? 'white'
                    : 'alert'
                }
                className='inline-flex h-fit w-fit items-center gap-sm px-3 py-[3px]'
              >
                <Icon
                  Icon='folder'
                  type='material'
                  className='text-mono-900 text-[14px]'
                />
                <Typography className='text-mono-900'>
                  {credits?.remainingCreditsMonth} créditos disponíveis
                </Typography>
              </Tag>
            </div>
            <div className='flex w-full flex-col gap-xs'>
              <Typography size='h2' type='title'>
                {data?.theme}
              </Typography>
            </div>
            <div className='flex w-full flex-row items-center justify-between'>
              <div className='inline-flex gap-sm'>
                {data?.textualGenre && data?.textualGenre?.main && (
                  <Chip
                    className={`shadow-level-none border-none bg-mono-color-lighter px-2 text-mono-color-black`}
                  >
                    {data.textualGenre.main.title}
                  </Chip>
                )}
                {data?.textualGenre && data?.textualGenre?.secondary && (
                  <Chip
                    className={`shadow-level-none border-none bg-mono-color-lighter px-2 text-mono-color-black`}
                  >
                    {data.textualGenre.secondary.title}
                  </Chip>
                )}
                {data?.correctionType && (
                  <Chip
                    className={`shadow-level-none border-none bg-mono-color-lighter px-2 text-mono-color-black`}
                  >
                    {essayTitle(data.correctionType)}
                  </Chip>
                )}
                {data?.webDoc && (
                  <Chip
                    className={`shadow-level-none border-none bg-mono-color-lighter px-2 text-mono-color-black`}
                  >
                    AprovaDoc
                  </Chip>
                )}
                {data?.axis && data?.axis.main.title && (
                  <Chip
                    className={`shadow-level-none border-none bg-mono-color-lighter px-2 text-mono-color-black`}
                  >
                    {data?.axis.main.title}
                  </Chip>
                )}
              </div>
              <div className='flex flex-row items-center gap-sm'>
                {/* <BadgeScore score={[1, 2]} /> */}

                <Tag
                  variant={
                    credits?.remainingCreditsMonth &&
                    credits?.remainingCreditsMonth > 0
                      ? 'white'
                      : 'alert'
                  }
                  className='h-fit w-fit items-center gap-sm px-3 py-[3px] xs:hidden md:inline-flex'
                >
                  <Icon
                    Icon='folder'
                    type='material'
                    className='text-[14px] text-mono-color-darkest'
                  />
                  <Typography>
                    {credits?.remainingCreditsMonth} créditos disponíveis
                  </Typography>
                </Tag>
              </div>
            </div>
          </div>
          {(data?.webDoc || data?.themeLesson || data?.teacherLesson) && (
            <div className='flex w-full gap-lg xs:flex-col md:flex-row'>
              {data?.webDoc && data?.webDoc.vimeoID && (
                <div className={getVideoWidthClass()}>
                  <Player
                    contentId={data?.webDoc._id}
                    playerType="vimeo"
                    token={data?.webDoc.vimeoID}
                    initialTime={0}
                    className='w-full xs:h-[40vh] md:h-[45vh] lg:h-[50vh]'
                  />
                </div>
              )}
              {data?.themeLesson && data?.themeLesson.vimeoID && (
                <div className={getVideoWidthClass()}>
                  <Player
                    contentId={data?.themeLesson._id}
                    playerType="vimeo"
                    token={data?.themeLesson.vimeoID}
                    initialTime={0}
                    className='w-full xs:h-[40vh] md:h-[45vh] lg:h-[50vh]'
                  />
                </div>
              )}
              {data?.teacherLesson && data?.teacherLesson.vimeoID && (
                <div className={getVideoWidthClass()}>
                  <Player
                    contentId={data?.teacherLesson._id}
                    playerType="vimeo"
                    token={data?.teacherLesson.vimeoID}
                    initialTime={0}
                    className='w-full xs:h-[40vh] md:h-[45vh] lg:h-[50vh]'
                  />
                </div>
              )}
            </div>
          )}
          {data?.guide && (
            <Button
              size='regular'
              LeftIcon='open_in_new'
              iconSize='small'
              variant='text'
              onClick={() => open(data.guide, '__bank')}
              className='p-0'
            >
              Guia de redação
            </Button>
          )}
          <div>
            <InnerHTMLContainer
              type='theme'
              align='left'
              font='noto'
              data={removeAlign(data?.description) || ''}
              className='flex-col items-start text-mono-color-darkest'
            />
          </div>
          <div className='mb-20'>
            <InnerHTMLContainer
              type='theme'
              align='left'
              font='noto'
              data={removeAlign(data?.motivationalText) || ''}
              className='flex-col items-start text-mono-color-darkest'
            />
          </div>
          <EssayFooter
            onStart={() => startEssay()}
            alreadySended={false}
            paperURL={board.paper}
          />
        </Fragment>
      )}
    </Container>
  );
}
